import { h, Fragment, VNode } from "preact";
import { useState } from "preact/hooks";

function pass<T>(fn: () => T){
    return fn();
}

export function SimpleList<T>(props: {
    elements: T[],
    style?: string,
    keyAccessor: (value: T) => string,
    children: (item: T) => VNode,
    onChange: (value: T) => void,
    value: T,
    header: string,
    emptyListMessage: string
}) {
    return <div style={"border: 1px solid rgba(255, 255, 255, 0.14); padding-bottom: 10px; " + props.style}>
        <h3 style="padding: 4px 10px; margin: 0; background: rgba(255, 255, 255, 0.14)">{props.header}</h3>
        {pass(() => {
            if (props.elements.length === 0) {
                return <div style="padding: 2px 10px; margin: 2px 0px;">{props.emptyListMessage}</div>;
            }

            return <div class="list">
                {props.elements.map(v =>
                    <div
                        class={"primary item" + (props.keyAccessor(props.value) === props.keyAccessor(v) ? " selected" : "")}
                        style="padding: 4px 10px; margin: 2px 0px; display: flex; align-items: center;"
                        onClick={() => props.onChange(v)}
                    >
                        {props.children(v)}
                    </div>)
                }
            </div>
        })}
    </div>;
}
